<template>
    <div class="placa-html">
        <div class="placa-container">
            <div :class="classePlaca">
                <div class="placa-header">
                    <div class="placa-pais">{{ pais }}</div>
                </div>
                <div class="placa-content">
                    <div class="placa-numero">{{ placa }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import { defineComponent } from 'vue';

export default defineComponent({
    name: 'PlacaMercosul',
    props: {
        placa: {
            type: String,
            required: true
        },
        pais: {
            type: String,
            default: 'BRASIL'
        },
        tamanho: {
            type: String,
            default: '' 
        }
    },

    computed: {
        classePlaca() {
            if (this.tamanho === 'grande') {
                return 'placa-mercosul placa-grande';
            } else if (this.tamanho === 'media') {
                return 'placa-mercosul placa-media';
            } 
            
            return 'placa-mercosul';
        }
    }
    
});

</script>

<style scoped>
.placa-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

/* .placa-container {
    display: inline-block;
} */

.placa-mercosul {
    position: relative;
    width: 100px;
    height: 33px;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #003399;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    font-family: 'Arial', sans-serif;
}

.placa-header {
    display: flex;
    height: 8px;
    background-color: #003399;
    color: white;
    padding: 0 5px;
}

.placa-pais {
    align-items: center;
    text-align: center;
    font-size: 6px;
    font-weight: bold;
    width: 100%;
    position: relative;
}

.placa-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
}

.placa-numero {
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #000;
    text-align: center;
}

/*Placa media */
.placa-mercosul.placa-media {
    width: 120px;
    height: 40px;
}

.placa-mercosul.placa-media .placa-header {
    height: 10px;
}

.placa-mercosul.placa-media .placa-pais {
    font-size: 7px;
}

.placa-mercosul.placa-media .placa-numero {
    font-size: 18px;
    letter-spacing: 1.2px;
}

/* Placa grande */
.placa-mercosul.placa-grande {
    width: 140px;
    height: 46px;
}

.placa-mercosul.placa-grande .placa-header {
    height: 11px;
}

.placa-mercosul.placa-grande .placa-pais {
    font-size: 8px;
}

.placa-mercosul.placa-grande .placa-numero {
    font-size: 20px;
    letter-spacing: 1.5px;
}




</style>
